import { applicationFeedBack } from './reducers';
export default applicationFeedBack;
